<template>
    <div>
        <c-dialog ref="dialog" :title="dialogTitle" width="800" height="550">
            <div v-if="active == 1" class="tip-div">
                <div class="import-steps">
                    <h5>步骤一、下载导入模板</h5>
                    <p>·请按照模板中的列头批注说明填写完善表格中的内容。点击这里<a style="color: blue;" @click="downloadTemplate()">下载模板</a></p>
                    <p>
                        ·下载模板后，请按<a style="color: blue;" @click="showNoticeMsg()">导入说明</a>照填写完善表格中的内容;
                    </p>
                    <p>·当上传的表格有多个Sheet时，仅解析第一个Sheet的数据；<span style="color:red">请保证导入Excel的第一行为表头信息</span>。</p>
                    <p>·仅保留近30天的导入数据记录，请点击<a style="color: blue;" @click="showImportLogs()">导入历史</a>查看。</p>
                </div>
            </div>
            <div v-if="active == 1" class="tip-div">
                <div class="import-steps">
                    <h5>步骤二、上传完善好的表格</h5>
                    <p>·仅支持上传Excel文件(Excel2007及以上版本)，导入文件最大不超过5MB，数据不超过<span style="color: blue">{{uploadFileRowLimit}}</span>行。</p>
                    <c-button hollow size="m" @click="uploadHandle"><i class="tf tf-file-xls"></i>上传导入文件</c-button>
                </div>
            </div>
            <div v-if="active == 2" class="tip-div">
                <div class="import-steps">
                    <p>1、 带<b style="margin: 0 5px; color: #f00;">*</b>的数据必须填写（选择对应的Excel表头）。</p>
                    <p>2、 导入数据会优先从Excel数据列中取值，如果对应的单元格数据为空，将使用【默认数据】中填写的值进行填充。</p>
                </div>
            </div>
            <div v-if="active == 2">
                <c-table ref="table" v-model="matchColumnList" height="320" border :paging="false">
                    <c-table-column :label="'系统字段 (共 '+sysColumnTotal+' 列)'" width="250" fixed="left">
                        <template #default="{data}">
                            <div class="flex-left">
                                {{data.system_column_name}}
                                <b v-if="data.required==1" style="margin-left: 5px; font-size: 14px; color: #f00;">*</b>
                            </div>
                        </template>
                    </c-table-column>
                    <c-table-column :label="'Excel表头 (共 '+excelColumnTotal+' 列)'" width="300">
                        <template #default="{data}">
                            <c-select name="excel_column_name" :options="excelColumnOptions" v-model="data.excel_column_name"></c-select>
                        </template>
                    </c-table-column>
                </c-table>
            </div>

            <div v-if="active == 3" class="tip-div">
                <div class="import-fruit flex-column flex-center" v-if="errorFlag">
                    <h1 style="color: red">导入失败</h1>
                    <span style="color: #bd2c00">
                    {{this.errorMag}}
                </span>
                </div>
                <div class="import-fruit flex-column flex-center" v-if="!errorFlag && importModel == 1">
                    <h1>导入结果</h1>
                    <p>
                        共导入
                        {{this.importResult.total_count}}条数据；
                        成功：<b style="color: green">{{this.importResult.success_count}}条</b>；
                        失败：<b style="color: red">
                        {{this.importResult.fail_count}}条
                    </b>
                        <a v-if="this.importResult.fail_count > 0 && this.importResult.error_file_url" style="color:blue; margin-left: 20px;" @click="downloadErrorFile()">下载错误报告</a>
                    </p>
                </div>
                <div class="import-fruit flex-column flex-center" v-if="!errorFlag && importModel == 2">
                    <h1>导入请求已提交</h1>
                    <p>
                        共导入
                        {{this.importResult.total_count}}条数据；数据将异步完成处理，您可以在<a style="color: blue;" @click="showImportLogs()">导入历史</a>列表中关注执行状态和导入结果
                    </p>
                </div>
            </div>
            <template #button>
                <c-button v-if="active == 2" size="m" hollow @click="previousStep()">上一步</c-button>
                <c-button v-if="active == 2 && excel_file" size="m" @click="submit()">确定导入</c-button>
                <c-button v-if="!errorFlag && importModel == 1 && active == 3" size="m" hollow @click="previousStep()">继续导入</c-button>
                <c-button v-if="!errorFlag && importModel == 1 && active == 3" size="m" @click="finish()">导入完成</c-button>
                <c-button v-if="!errorFlag && importModel == 2 && active == 3" size="m" @click="finish()">知道了</c-button>
                <c-button v-if="errorFlag && active == 3" size="m" @click="previousStep()">重新导入</c-button>
            </template>

            <!--提示信息-->
            <c-dialog ref="noticeDialog" width="700" title="导入说明" button-name="我知道了" :cancel-button="false">
                <div v-html="noticeMsg" class="import-explain"></div>
            </c-dialog>
        </c-dialog>
        <import-log ref="importLog" :work-type="workType"></import-log>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import nodeList from "@/components/public/node_list.vue";
    import importLog from "@/components/service/import_log_record.vue";

export default {
    name: 'excelImport',
    components: {importLog, nodeList},
    props: {
        workType: [String, Number]
    },
    watch: {
    },
    data() {
        return {
            title:'导入数据',
            active:1,
            import_type:1,
            excel_file:'',              //上传文件路径
            matchColumnList:[],
            sysColumnTotal:0,           //系统业务总列数
            excelColumnTotal:0,         //导入Excel总列表
            excelColumnOptions:[],       //导入Excel表头信息（去重）
            importResult:null,
            importModel:1,               //数据导入模式 1=同步 2=异步
            errorFlag:false,
            errorMag:''
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['userInfo', 'systemConfig']),

        nodeList() {
            return [
                {name: '上传文件'},
                {name: '配置表单'},
                {name: '导入数据'}
            ]
        },

        noticeMsg() {

            var resultMsg = {
                901: [
                    '<p>1、订单编号：<span style="color:red">【必填】</span>，最多输入 50 个字符；<strong>必须是系统中存在的单号</strong>；</p>',
                    '<p>2、SKU编码；<span style="color:red">【必填】</span>，最多输入 50 个字符，填写了则表示仅发该SKU的商品，未填写则表示整个订单全部发货；<strong>必须是系统中存在的SKU编码（区分英文大小写）</strong>；</p>',
                    '<p>4、发货数量；<span style="color:red">【必填】</span>，必须输入1~9999之间的正整数；<strong>导入的所有同一个订单中的SKU数量总和不能超过可发数量，否则所有SKU记录发货失败</strong>；</p>',
                    '<p>5、物流公司；<span style="color:red">【必填】</span>，填写物流公司名称；<strong>该名称必须在【商品->运费设置->发货物流】功能中已配置</strong>；</p>',
                    '<p>6、运单号；<span style="color:red">【选填】</span>，最多输入 50 个字符,当发货物流等于【自提】或【公司配置】时，运单号允许为空，其他情况必须填写。<strong>一个运单号只允许使用一次</strong>；</p>',
                    '<p>•导入发货数据时，请保证数据表中的<span style="color:red">【订单号】+【SKU编码】+【物流公司】+【运单号】</span>唯一。</p>',
                ].join(''),
                902: [
                    '<p>1、会员手机号：<span style="color:red">【必填】</span>，最多输入 50 个字符；<strong>必须是系统中存在的手机号</strong>；</p>',
                    '<p>2、SKU编码：<span style="color:red">【必填】</span>，最多输入 50 个字符；<strong>必须是系统中存在的SKU编码</strong>；</p>',
                    '<p>3、变更云仓库存；<span style="color:red">【必填】</span>，在原有基础上增加或减少云仓库存，必须输入非0数字，取值范围[-99999,-1],[1,99999]；</p>',
                    '<p style="text-indent: 2em;">a）、负数表示云仓库存减少;<strong>云仓库存最少减为0，不会出现负数</strong>；</p>',
                    '<p style="text-indent: 2em;">b）、正式表示云仓库存增加；</p>',
                    '<p style="text-indent: 2em;">c）、库存信息不填写或者填写0，则会导入失败；</p>',
                    '<p>4、商品名称；<span style="color:blue">【选填】</span>，该字段仅用作展示，导入时不会使用；</p>',
                    '<p>5、商品规格；<span style="color:blue">【选填】</span>，该字段仅用作展示，导入时不会使用；</p>',
                    '<p>•导入数据时，请保证数据表中的<span style="color:red">【会员手机号】+【SKU编码】</span>唯一。</p>',
                ].join(''),
                903: [
                    '<p>1、会员手机号：<span style="color:red">【必填】</span>，最多输入 50 个字符；不填写手机号则数据行直接忽略；<strong>该手机号必须尚未注册，否则导入失败</strong>；</p>',
                    '<p>2、昵称：<span style="color:blue">【选填】，</span>最多输入 50 个字符；</p>',
                    '<p>3、等级；<span style="color:blue">【选填】</span>，普通会员则填写：“普通会员”；代理用户则填写【代理等级】功能中的等级名称；不填写则认为是“普通会员”；填写其他内容则导入失败</p>',
                    '<p>4、邀请人手机号；<span style="color:blue">【选填】</span>，无邀请人则填写“无”或者不填写任何内容；所填写的邀请人手机号必须在系统中已存在或者当前导入Excel中存在；</p>',
                    '<p>•导入数据时，请保证数据表中的<span style="color:red">【会员手机号】</span>唯一，否则，重复的手机号的所有数据均导入失败。</p>',
                ].join(''),
                904: [
                    '<p>1、商品标题：<span style="color:red">【必填】</span>，请输入商品标题，最多输入100个字符<strong>相同标题则认为是相同商品，区分英文大小写</strong>；</p>',
                    '<p>2、一级类目：<span style="color:red">【必填】</span>，请填写【类目管理】功能中的一级类目名称；<strong>对应类目信息必须已存在，区分英文大小写</strong>；</p>',
                    '<p>3、二级类目：<span style="color:blue">【选填】</span>，请填写【类目管理】功能中的二级类目名称，无二级类目可不填写；<strong>对应类目信息必须已存在，区分英文大小写</strong>；</p>',
                    '<p>4、三级类目：<span style="color:blue">【选填】</span>，请填写【类目管理】功能中的三级类目名称，无三级类目可不填写；<strong>对应类目信息已存在，区分英文大小写</strong>；</p>',
                    '<p>5、销售模式：<span style="color:blue">【选填】</span>，请填写商品销售模式，如必填项，则该商品的销售模式默认为<strong>【供货】</strong>；</p>',
                    '<p>6、商品卖点：<span style="color:blue">【选填】</span>，请输入商品商品卖点信息，最多输入100个字符；</p>',
                    '<p>7、商品货号：<span style="color:blue">【选填】</span>，请输入商品商品货号信息，最多输入50个字符；<strong>货号区分英文大小写</strong>；</p>',
                    '<p>8、商品品牌：<span style="color:blue">【选填】</span>，请输入商品品牌名称，<strong>该品牌必须在【品牌管理】功能中已存在</strong>；</p>',
                    '<p>9、可售范围：<span style="color:blue">【选填】</span>，请输入会员等级名称，多个可售范围以英文逗号分隔；<span style="color:red">不填写数据则默认所有用户可见</span>，</p>',
                    '<p style="text-indent: 2em;">a）、普通会员请输入“普通会员”四个字(不含引号)；</p>',
                    '<p style="text-indent: 2em;">b）、其他等级会员，请输入【会员等级】功能中的等级名称；</p>',
                    '<p style="text-indent: 2em;">c）、同时允许多个等级可见请以逗号分隔输入：例如：“普通会员,VIP”(不含引号)；</p>',
                    '<p>10、缺货订购：<span style="color:blue">【选填】</span>，当前商品是否支持缺货订购，可选值如下：不支持、支持；<strong>不填写则默认不支持</strong>；</p>',
                    '<p>11、运费模板：<span style="color:blue">【选填】</span>，请输入当前商品应用的运费模板名称；<strong>模板名称必须在【运费模板】中已存在；不填写则默认使用模板：<span style="color:red">默认模板【计件】</span>，</strong>；</p>',
                    '<p>12、一级规格：<span style="color:blue">【选填】</span>，请输入一级规格，例如产品的“颜色”信息<strong>最多输入100个字符，区分英文大小写</strong>；</p>',
                    '<p>13、二级规格：<span style="color:blue">【选填】</span>，请输入二级规格，例如产品某个“颜色”下的码段信息“21-30码”<strong>最多输入100个字符，区分英文大小写</strong>；</p>',
                    '<p>14、三级规格：<span style="color:blue">【选填】</span>，请输入二级规格，例如产品某个“颜色+码段”下的具体尺码信息：“25码”<strong>最多输入100个字符，区分英文大小写</strong>；</p>',
                    '<p style="text-indent: 2em;color:red">a）、一级、二级、三级规格必须按照顺序填写；不允许出现不存在一级规格，但是存在二三级规格的数据</p>',
                    '<p>15、商品SKU售价：<span style="color:red">【必填】</span>，商品SKU售价<strong>只能输入大于0的数字</strong>；</p>',
                    '<p>16、商品SKU库存：<span style="color:blue">【选填】</span>，请输入SKU库存信息<strong>只能输入大于0的数字，不填写则默认0</strong>；</p>',
                    '<p>17、商品SKU重量(kg)：<span style="color:blue">【必填】</span>，商品SKU重量<strong>只能输入大于0的数字</strong>；</p>',
                    '<p>18、商品SKU编码：<span style="color:blue">【选填】</span>，商品SKU编码<strong>编码全局唯一，不填写则默认生成</strong>；</p>',
                    '<p>•导入数据时，请保证相同商品（商品标题）对应的类目、销售模式、卖点、货号、品牌、可售范围、缺货订购、运费模板等信息一致，如果存在不一致的情况，则以第一条数据为准。</p>',
                    '<p>•导入数据时，请保证数据表中的<span style="color:red">【商品标题】+【一级规格】+【二级规格】+【三级规格】</span>唯一，否将导入失败。</p>',
                ].join('')
            }[this.workType];
            var commonMsg = [
                '<p><span style="color:darkgray">• 时间类型字段：支持格式YYYY-MM-DD HH:mm和YYYY/MM/DD HH:mm。</span></p>',
                '<p><span style="color:darkgray">• 数字类型字段：整数位请勿超过 10 位，小数位请勿超过 6 位。</span></p>'
            ].join('')
            return resultMsg + commonMsg;
        },

        dialogTitle() {
            var workTypeName = {
                901: '【批量发货】',
                902: '【云仓库存】',
                903: '【会员】',
                904: '【商品】'
            }[this.workType];
            workTypeName = '导入'+workTypeName+'数据';
            return workTypeName;
        },
        /**
         * 最大行数限制
         */
        uploadFileRowLimit() {
            var rowCount = {
                901:1000,
                902:1000,
                903:50000,
                904:50000
            }[this.workType];
            return rowCount||1000;
        }
    },

    methods: {
        /************打开新增、编辑弹窗，数据初始化**************/
        open() {
            this.import_type = 1;//仅新增
            this.active = 1;//恢复初始值
            this.excel_file = '';
            this.errorFlag = false;
            this.$refs.dialog.open();
        },

        /*******搜索【仓库】下拉框信息*****************/
        searchWarehouse(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'WAREHOUSE',
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },

        /*****************下载导出模板**********************/
        downloadTemplate(){
            this.request({
                url: '/import/url',
                data:{
                    work_type:this.workType
                },
                success: data => {
                    this.download({
                        fileName: data.filename,
                        url: data.url,
                        loading: {
                            message: '数据文件生成中...'
                        }
                    });
                }
            });
        },

        /*****************展示导入说明数据**********************/
        showNoticeMsg(){
            this.$refs.noticeDialog.open();
        },

        /*****************展示导入历史数据**********************/
        showImportLogs(){
            this.$refs.importLog.open();
        },

        /*****************上传文件**********************/
        uploadHandle() {
            this.uploadFile({
                fileType:'xls,xlsx',
                success: data => {
                    this.excel_file = data.filePath||'';
                    if (!this.excel_file){
                        this.$message({
                            text: '请上传文件',  // 提示内容,
                            type: 'warn'
                        });
                        return;
                    }
                    var suffix = this.excel_file.substring(this.excel_file.lastIndexOf('.')+1).toLowerCase();
                    if (suffix!='xls' && suffix!='xlsx'){
                        this.$message({
                            text: '请上传Excel文件',  // 提示内容,
                            type: 'warn'
                        });
                        return;
                    }
                    //执行分析
                    this.analysisUploadFile();
                }
            });
        },

        /*****************解析上传成功的Excel文件**********************/
        analysisUploadFile() {
            this.request({
                url: '/import/analysis/excel/head',
                data: {
                    work_type: this.workType,
                    view_id: this.view_id,
                    url: this.excel_file
                },
                loading: {
                    message: '文件上传解析中...'
                },
                success: data => {
                    this.errorFlag = false;
                    this.matchColumnList = data.matchColumnList || [];
                    this.sysColumnTotal = data.sysColumnTotal || 0;
                    this.excelColumnTotal = data.excelColumnTotal || 0;
                    this.excelColumnOptions = data.excelColumnOptions || [];
                    setTimeout(() => {
                        this.active = 2;//上传文件完成，跳转配置表单页面
                    }, 500);
                },
                fail: () => {
                    this.errorFlag = true;
                }
            });
        },

        //回退至上一步
        previousStep(){
            this.active = 1;
        },

        //完成
        finish(){
            this.$refs.dialog.close();
        },
        /************下载错误文件************/
        //
        submit(){
            //判断【必填】项是否已填写
            var submitFlag = true;
            this.matchColumnList.forEach(item => {
                if (item.required==1
                        && (!item.excel_column_name || item.excel_column_name == '')
                        && (!item.column_default_value || item.column_default_value == '')
                ){
                    submitFlag = false;
                    this.$message({
                        text: '请完善所有带星号的【必填】数据列',  // 提示内容,
                        type: 'warn'
                    });
                    return;
                }
            });
            if (submitFlag){
                this.request({
                    url: '/import/analysis/excel/data',
                    data: {
                        work_type:this.workType,
                        view_id:this.view_id,
                        url: this.excel_file,
                        match_column_list: this.matchColumnList,
                        import_type: this.import_type,
                        warehouse_id: this.warehouse_id,
                        order_classify: this.order_classify
                    },
                    loading: {
                        message: '导入数据处理中...'
                    },
                    success: data => {
                        this.errorFlag = false;
                        this.importResult = data;
                        this.importModel = data.import_model||1;
                        setTimeout(() => {
                            this.active = 3;//恢复初始值
                            //执行回调方法
                            this.$emit('resolve');
                        }, 500);
                    },
                    fail: (code,obj,message) => {
                        this.active = 3;//恢复初始值
                        this.errorMag = message;
                        this.errorFlag = true;
                    }
                });
            }
        },

        /************下载错误文件************/
        downloadErrorFile() {
            this.download({
                fileName: this.importResult.error_file_name,
                url: this.importResult.error_file_url,
                loading: {
                    message: '数据文件生成中...'
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.tip-div {
    /* 四个值：上 | 右 | 下 | 左 */
    padding: 20px 20px 20px 20px;
}

.import-steps {
    padding: 10px 20px;
    background-color: #F8F8F8;

    h5 {
        line-height: 36px;
        font-size: 15px;
    }

    p {
        padding: 4px 0;
        line-height: 20px;
        color: #666;
    }
}

.import-explain {
    padding: 20px;

    >>> p {
        padding: 4px 0;
        line-height: 20px;
    }
}

.import-fruit {
    height: 200px;
    background-color: #F8F8F8;

    h1 {
        margin-bottom: 30px;
        font-size: 26px;
    }
}
</style>